class ProductMediaGrid extends HTMLElement {
  constructor() {
    super()
    this.swiperInstance = null
    this.swiperContainer = this.querySelector('.swiper')
    this.swiperWrapper = this.querySelector('#swiper-wrapper')
    this.initializeSwiper()

    this.initializePinchZoom()

    this.resized(this)
    window.addEventListener("resize", (event) => {
      this.resized(this)
    })

  }

  initializeSwiper() {
    this.swiperInstance = new Swiper(this.swiperContainer, {
      loop: true,
      enabled: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }

  resized() {
    if (this.swiperInstance === null) { return }

    if (document.body.clientWidth < 768) {
      if (this.swiperInstance.destroyed == true) {
        this.swiperWrapper.classList.add('swiper-wrapper')
        this.initializeSwiper()
      }
    } else {
      if (this.swiperInstance.enabled == true) {
        this.swiperInstance.destroy()
        this.swiperWrapper.classList.remove('swiper-wrapper')
      }
    }
  }

  initializePinchZoom() {
    this.zoomableImages = this.querySelectorAll('.swiper-slide img')
    // this.zoomableImageScale = 1
    // this.start = {}

    console.log(this.zoomableImages)

    this.zoomableImages.forEach((zoomableImage) => {
      let zoomableImageScale = 1
      let start = {}

      zoomableImage.addEventListener('touchstart', (event) => {
        if (event.touches.length === 2) {
          event.preventDefault() // Prevent page scroll

          // zoomableImage.style.transition = ''

          // Calculate where the fingers have started on the X and Y axis
          start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2
          start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2
          start.distance = this.distance(event)

        }
      })

      zoomableImage.addEventListener('touchmove', (event) => {
        if (event.touches.length === 2) {
          event.preventDefault(); // Prevent page scroll

          // https://vmorneau.me/new-pinch-and-zoom/
          // Safari provides event.scale as two fingers move on the screen
          // For other browsers just calculate the scale manually
          let scale
          if (event.scale) {
            scale = event.scale
          } else {
            const deltaDistance = this.distance(event)
            scale = deltaDistance / this.start.distance
          }
          zoomableImageScale = Math.min(Math.max(1, scale), 4)

          // Calculate how much the fingers have moved on the X and Y axis
          let deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 1 // x2 for accelarated movement
          let deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 1 // x2 for accelarated movement

          // Disable Swiper
          this.swiperInstance.allowTouchMove = false

          // Transform the image to make it grow and move with fingers
          const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${zoomableImageScale})`
          zoomableImage.style.transform = transform
          zoomableImage.style.WebkitTransform = transform
          zoomableImage.style.zIndex = "9999"

        }
      })
      zoomableImage.addEventListener('touchend', (event) => {
        // Reset image to it's original format
        // zoomableImage.style.transition = 'all .1s'
        zoomableImage.style.transform = ""
        zoomableImage.style.WebkitTransform = ""
        zoomableImage.style.zIndex = ""

        // Enable Swiper
        this.swiperInstance.allowTouchMove = true
      })
    })
  }

  distance(event) {
    return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY)
  }
}

customElements.define('product-media-grid', ProductMediaGrid)